<template>
  <v-container id="pedidosform" tag="section">
    <base-v-component :heading="formTitle" />
    <base-material-card
      color="indigo"
      icon="mdi-basket"
      inline
      class="px-5 py-3"
    >
      <v-chip class="ma-2" color="primary" text-color="white" x-large chip>{{
        this.estado
      }}</v-chip>
      <v-card-text>
        <v-container grid-list-md>
          <v-overlay id="downloading-pedidos" absolute v-model="overlayPedidos">
            <v-alert class="info"
              >Estamos descargando los pedidos, llevamos
              {{ downloadedPedidos }}</v-alert
            >
          </v-overlay>
          <v-row justify="center">
            <v-col cols="12" sm="4">
              <v-autocomplete
                @change="generarNombreFactura"
                :loading="loadingSelect"
                :items="negociosItems"
                label="Negocio"
                v-model="negocio"
                :disabled="ver"
              />
              <v-alert v-if="factNegocio" class="pa-2 caption warning"
                >Se factura todo el negocio</v-alert
              >
              <v-alert
                v-else-if="factIndependiente"
                class="pa-2 caption warning"
                >Se factura cada restaurante independientemente</v-alert
              >
              <v-alert v-else-if="factDirectorio" class="pa-2 caption warning"
                >Se factura el directorio completo</v-alert
              >
              <v-card v-if="(factNegocio || factDirectorio) && !id_factura">
                <v-row>
                  <v-row justify="center">
                    <v-col cols="12" sm="4">
                      <v-text-field
                        disabled
                        type="number"
                        step="0.01"
                        label="Porcentaje por pedido pago online"
                        v-model="
                          datosFacturacionNegocio.tasaPorcentajePedidoPagoOnline
                        "
                      />
                    </v-col>
                    <v-col cols="12" sm="4">
                      <v-text-field
                        disabled
                        type="number"
                        step="0.01"
                        label="Valor fijo por pedido pago online"
                        v-model="
                          datosFacturacionNegocio.tasaFijaPedidoPagoOnline
                        "
                      />
                    </v-col>
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="12" sm="4">
                      <v-text-field
                        disabled
                        type="number"
                        step="0.01"
                        label="Porcentaje por pedido"
                        v-model="datosFacturacionNegocio.tasaPorcentajePedido"
                      />
                    </v-col>
                    <v-col cols="12" sm="4">
                      <v-text-field
                        disabled
                        type="number"
                        step="0.01"
                        label="Valor fijo por pedido pago online"
                        v-model="datosFacturacionNegocio.tasaFijaPedido"
                      />
                    </v-col>
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="12" sm="4">
                      <v-text-field
                        disabled
                        type="number"
                        step="0.01"
                        label="Tasa fija de servicio"
                        v-model="datosFacturacionNegocio.tasaFijaServicio"
                      />
                    </v-col>
                  </v-row>
                </v-row>
              </v-card>
            </v-col>
            <v-col cols="12" sm="4">
              <v-autocomplete
                v-if="factIndependiente"
                :disabled="ver"
                item-text="nombre"
                item-value="id"
                :items="restaurantesFiltrados"
                @change="cambioRestaurante"
                :loading="loadingSelect"
                label="Restaurante"
                v-model="restaurante"
              >
                <template v-slot:item="data">
                  <v-list-item-title v-if="data.item.disabled"
                    >{{ data.item.nombre }} - Factura
                    {{ data.item.copiarRest }}</v-list-item-title
                  >
                  <v-list-item-title v-else>{{
                    data.item.nombre
                  }}</v-list-item-title>
                </template>
                <template v-slot:prepend-item>
                  <v-list-item ripple>
                    <v-list-item-content>
                      <v-list-item-title
                        >Restaurantes a facturar</v-list-item-title
                      >
                      <v-list-item-subtitle
                        v-for="(r, i) in restaurantesArray"
                        :key="i"
                        >{{ r.nombre }}</v-list-item-subtitle
                      >
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="mt-2"></v-divider>
                </template>
                <template v-slot:selection="{ item }">
                  <v-chip v-if="restaurantesArray.length === 1">
                    <span>{{ item.nombre }}</span>
                  </v-chip>
                  <v-chip v-if="restaurantesArray.length > 1">
                    <span>{{ item.nombre }}</span>
                    <span class="grey--text caption"
                      >(+{{ restaurantesArray.length - 1 }} más)</span
                    >
                  </v-chip>
                </template>
              </v-autocomplete>
              <v-card v-if="factIndependiente">
                <v-row>
                  <v-row justify="center">
                    <v-col cols="12" sm="4">
                      <v-text-field
                        disabled
                        type="number"
                        step="0.01"
                        label="Porcentaje por pedido pago online"
                        v-model="
                          facturacionRestaurante.tasaPorcentajePedidoPagoOnline
                        "
                      />
                    </v-col>
                    <v-col cols="12" sm="4">
                      <v-text-field
                        disabled
                        type="number"
                        step="0.01"
                        label="Valor fijo por pedido pago online"
                        v-model="
                          facturacionRestaurante.tasaFijaPedidoPagoOnline
                        "
                      />
                    </v-col>
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="12" sm="4">
                      <v-text-field
                        disabled
                        type="number"
                        step="0.01"
                        label="Porcentaje por pedido"
                        v-model="facturacionRestaurante.tasaPorcentajePedido"
                      />
                    </v-col>
                    <v-col cols="12" sm="4">
                      <v-text-field
                        disabled
                        type="number"
                        step="0.01"
                        label="Valor fijo por pedido pago online"
                        v-model="facturacionRestaurante.tasaFijaPedido"
                      />
                    </v-col>
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="12" sm="4">
                      <v-text-field
                        disabled
                        type="number"
                        step="0.01"
                        label="Tasa fija de servicio"
                        v-model="facturacionRestaurante.tasaFijaServicio"
                      />
                    </v-col>
                  </v-row>
                </v-row>
              </v-card>
            </v-col>
            <v-col cols="12" sm="4">
              <v-date-picker
                v-if="negocio != null"
                :readonly="ver || previsualizar"
                @change="generarNombreFactura"
                first-day-of-week="1"
                v-model="dates"
                range
                locale="es"
              ></v-date-picker>
            </v-col>
          </v-row>
          <v-row justify="center" v-if="borrador">
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="nombreFactura"
                label="Nombre de la factura"
              />
            </v-col>
            <v-col cols="6" sm="2">
              <v-btn
                :loading="loadingPrevisualizar"
                big
                @click="previsualizarMetodo"
                >PREVISUALIZAR DATOS</v-btn
              >
            </v-col>
          </v-row>
          <v-row justify="center" v-if="previsualizar">
            <v-col cols="6" sm="4">
              <v-btn
                :loading="loadingGenerar"
                big
                @click="generarFactura"
                class="primary"
                >GENERAR FACTURA</v-btn
              >
            </v-col>
          </v-row>
        </v-container>
        <!-- DATOS GENERADOS-->
        <v-container v-if="!borrador">
          <v-card>
            <v-tabs
              v-model="tab"
              background-color="deep-purple accent-4"
              centered
              dark
              icons-and-text
              grow
            >
              <v-tabs-slider></v-tabs-slider>

              <v-tab
                v-if="
                  !(
                    (estado == 'generada' || estado == 'archivada') &&
                    pedidosFactura.length == 0
                  )
                "
              >
                PEDIDOS
                <v-icon>mdi-shopping</v-icon>
              </v-tab>
              <v-tab>
                CONCEPTOS
                <v-icon>mdi-currency-eur</v-icon>
              </v-tab>

              <v-tab>
                RESUMENES
                <v-icon>mdi-view-dashboard</v-icon>
              </v-tab>

              <v-tab>
                FICHEROS
                <v-icon>mdi-file</v-icon>
              </v-tab>
              <v-tab>
                ACCIONES
                <v-icon>mdi-send</v-icon>
              </v-tab>
              <v-tab>
                HISTORIAL
                <v-icon>mdi-book</v-icon>
              </v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab">
              <v-tab-item
                key="0"
                v-if="
                  !(
                    (estado == 'generada' || estado == 'archivada') &&
                    pedidosFactura.length == 0
                  )
                "
              >
                <v-card flat>
                  <v-card-text>
                    <v-data-table
                      :headers="headers"
                      :items="pedidosFactura"
                      :must-sort="true"
                      sort-by="fecha"
                      :sort-desc="true"
                    >
                      <template v-slot:item="{ item }">
                        <tr :class="item.eliminado ? 'red lighten-2' : ''">
                          <td>{{ item.id }}</td>
                          <td>{{ item.fecha }}</td>
                          <td>{{ item.modo }}</td>
                          <td>{{ item.forma_pago }}</td>
                          <td>{{ item.precioTotal }}</td>
                          <td>{{ item.tasaPagoTarjetaPorcentaje }}</td>
                          <td>{{ item.tasaPagoTarjetaFijo }}</td>
                          <td>{{ item.tasaPedidoPorcentaje }}</td>
                          <td>{{ item.tasaPedidoFijo }}</td>
                          <td>{{ item.tasaTotal }}</td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item key="1">
                <v-row justify="center">
                  <v-col cols="12" sm="10" md="8">
                    <v-card flat max-width="600px">
                      <v-card-actions v-if="previsualizar">
                        <v-btn text @click="addConcepto"
                          >Añadir nuevo concepto</v-btn
                        >
                        <v-spacer />
                        <v-switch v-model="addTarifaOnline"
                          >Tarifa online automática</v-switch
                        >
                      </v-card-actions>
                      <v-card-text>
                        <v-list>
                          <v-list-item
                            v-for="(concepto, i) in conceptosFacturar"
                            :key="i"
                          >
                            <v-list-item-icon v-if="previsualizar">
                              <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                  <v-btn
                                    @click="eliminarConcepto(concepto)"
                                    class="px-2 ml-1"
                                    color="red"
                                    min-width="0"
                                    small
                                    v-on="on"
                                  >
                                    <v-icon small>mdi-close</v-icon>
                                  </v-btn>
                                </template>
                                <span>Eliminar concepto</span>
                              </v-tooltip>
                            </v-list-item-icon>
                            <v-list-item-title>{{
                              concepto.textoMostrar
                            }}</v-list-item-title>
                            <v-chip class="green black--text" outlined chip>{{
                              concepto.cantidadMostrar
                            }}</v-chip>
                            <v-checkbox
                              class="ml-2"
                              v-model="concepto.seFactura"
                              :disabled="!previsualizar"
                              label="Facturable"
                            />
                          </v-list-item>
                        </v-list>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-tab-item>
              <v-tab-item key="2">
                <v-card flat>
                  <v-card-text>
                    <v-list>
                      <v-list-item>
                        <v-row justify="center">
                          <v-col cols="10" sm="8" lg="4">Total Factura:</v-col>
                          <v-col cols="2">
                            <v-chip color="success" outlined>{{
                              resumen.totalCantidadFacturar
                            }}</v-chip>
                          </v-col>
                        </v-row>
                      </v-list-item>
                      <v-divider />
                      <v-list-item>
                        <v-row justify="center">
                          <v-col cols="10" sm="8" lg="4"
                            >Total Cobrado por pedidos online:</v-col
                          >
                          <v-col cols="2">
                            <v-chip color="success" outlined>{{
                              resumen.totalFacturado
                            }}</v-chip>
                          </v-col>
                        </v-row>
                      </v-list-item>
                      <v-list-item>
                        <v-row justify="center">
                          <v-col cols="10" sm="8" lg="4"
                            >Total en Stripe:</v-col
                          >
                          <v-col cols="2">
                            <v-chip color="success" outlined>
                              <span v-if="!loadingStripe">{{
                                resumen.totalEnStripe
                              }}</span>
                              <span v-else>...cargando</span>
                            </v-chip>
                          </v-col>
                        </v-row>
                      </v-list-item>
                    </v-list>
                    <v-list-item>
                      <v-row justify="center">
                        <v-col cols="10" sm="8" lg="4"
                          >Total Coste Mewo Pedidos Online (sin
                          impuestos)</v-col
                        >
                        <v-col cols="2">
                          <v-chip color="success" outlined>{{
                            resumen.totalTasas
                          }}</v-chip>
                        </v-col>
                      </v-row>
                    </v-list-item>
                    <v-list-item>
                      <v-row justify="center">
                        <v-col cols="10" sm="8" lg="4"
                          >Próxima transferencia al cliente</v-col
                        >
                        <v-col cols="2" class="pa-0">
                          <template v-if="!cambiarCantidadStripe">
                            <v-row>
                              <v-col cols="6">
                                <v-chip color="success" outlined>{{
                                  resumen.totalTransferir
                                }}</v-chip>
                              </v-col>
                              <v-col cols="6">
                                <v-btn
                                  small
                                  class="secondary"
                                  @click="cambiarCantidadStripeMetodo"
                                  >Cambiar</v-btn
                                >
                              </v-col>
                            </v-row>
                          </template>
                          <template v-else>
                            <v-row>
                              <v-col cols="6">
                                <v-chip color="warning" outlined>
                                  <v-text-field
                                    v-model="cambiarCantidadStripeNuevo"
                                    label="cambiar cantidad"
                                  />
                                </v-chip>
                              </v-col>
                              <v-col cols="6">
                                <v-btn
                                  class="success"
                                  small
                                  @click="cambiarCantidadStripeConfirmar"
                                >
                                  <v-icon>mdi-check</v-icon>
                                </v-btn>
                              </v-col>
                            </v-row>
                          </template>
                        </v-col>
                      </v-row>
                    </v-list-item>
                    <v-list-item>
                      <v-row justify="center">
                        <v-col cols="10" sm="8" lg="4"
                          >Próxima transferencia a Mewosystems</v-col
                        >
                        <v-col cols="2">
                          <template v-if="!cambiarCantidadCobrar">
                            <v-row>
                              <v-col cols="6">
                                <v-chip color="success" outlined>{{
                                  resumen.transferirMewo
                                }}</v-chip>
                              </v-col>
                              <v-col cols="6">
                                <v-btn
                                  small
                                  class="secondary"
                                  @click="cambiarCantidadCobrarMetodo"
                                  >Cambiar</v-btn
                                >
                              </v-col>
                            </v-row>
                          </template>
                          <template v-else>
                            <v-row>
                              <v-col cols="6">
                                <v-chip color="warning" outlined>
                                  <v-text-field
                                    v-model="cambiarCantidadCobrarNuevo"
                                    label="cambiar cantidad"
                                  />
                                </v-chip>
                              </v-col>
                              <v-col cols="6">
                                <v-btn
                                  class="success"
                                  small
                                  @click="cambiarCantidadCobrarConfirmar"
                                >
                                  <v-icon>mdi-check</v-icon>
                                </v-btn>
                              </v-col>
                            </v-row>
                          </template>
                        </v-col>
                      </v-row>
                    </v-list-item>
                    <v-list-item>
                      <v-row justify="center">
                        <v-col cols="10" sm="8" lg="4"
                          >Cantidad adicional a pagar</v-col
                        >
                        <v-col cols="2">
                          <v-chip color="success" outlined>{{
                            resumen.totalPagar
                          }}</v-chip>
                        </v-col>
                      </v-row>
                    </v-list-item>
                    <v-divider />
                    <v-list-item>
                      <v-row justify="center">
                        <v-col cols="10" sm="8" lg="4">Total Domicilio</v-col>
                        <v-col cols="2">
                          <v-chip color="success" outlined>{{
                            resumen.totalDomicilio
                          }}</v-chip>
                        </v-col>
                      </v-row>
                    </v-list-item>
                    <v-list-item>
                      <v-row justify="center">
                        <v-col cols="10" sm="8" lg="4">Total Recoger</v-col>
                        <v-col cols="2">
                          <v-chip color="success" outlined>{{
                            resumen.totalRecoger
                          }}</v-chip>
                        </v-col>
                      </v-row>
                    </v-list-item>
                    <v-divider />
                    <v-list-item>
                      <v-row justify="center">
                        <v-col cols="10" sm="8" lg="4"
                          >Total Tarjeta Online</v-col
                        >
                        <v-col cols="2">
                          <v-chip color="success" outlined>{{
                            resumen.totalTarjetaOnline
                          }}</v-chip>
                        </v-col>
                      </v-row>
                    </v-list-item>
                    <v-list-item>
                      <v-row justify="center">
                        <v-col cols="10" sm="8" lg="4"
                          >Total Tarjeta Domicilio</v-col
                        >
                        <v-col cols="2">
                          <v-chip color="success" outlined>{{
                            resumen.totalTarjetaDomicilio
                          }}</v-chip>
                        </v-col>
                      </v-row>
                    </v-list-item>
                    <v-list-item>
                      <v-row justify="center">
                        <v-col cols="10" sm="8" lg="4">Total Efectivo</v-col>
                        <v-col cols="2">
                          <v-chip color="success" outlined>{{
                            resumen.totalEfectivo
                          }}</v-chip>
                        </v-col>
                      </v-row>
                    </v-list-item>
                    <v-list-item>
                      <v-row justify="center">
                        <v-col cols="10" sm="8" lg="4"
                          >Total Pago en Local</v-col
                        >
                        <v-col cols="2">
                          <v-chip color="success" outlined>{{
                            resumen.totalPagoEnLocal
                          }}</v-chip>
                        </v-col>
                      </v-row>
                    </v-list-item>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item key="3">
                <v-card flat>
                  <v-card-text v-if="previsualizar">
                    <v-alert class="info"
                      >Cuando se genere la factura se crearán los fichereos
                      asociados</v-alert
                    >
                  </v-card-text>
                  <v-card-text>
                    <v-row justify="center">
                      <v-col cols="12" sm="10" md="8">
                        <v-row
                          justify="center"
                          v-if="ficheros && ficheros.resumenFactura"
                        >
                          <v-col cols="6">Fichero Resumen</v-col>
                          <v-col cols="6">
                            <v-tooltip top>
                              <template v-slot:activator="{ on }">
                                <v-btn
                                  @click="openPdf(ficheros.resumenFactura)"
                                  class="px-2 ml-1"
                                  color="info"
                                  min-width="0"
                                  v-on="on"
                                  small
                                >
                                  <v-icon small>mdi-file-pdf-box</v-icon>
                                </v-btn>
                              </template>
                              <span>Descargar pdf</span>
                            </v-tooltip>
                          </v-col>
                        </v-row>
                        <v-row v-if="ficheros && ficheros.pedidos">
                          <v-col cols="6">Fichero pedidos</v-col>
                          <v-col cols="6">
                            <v-tooltip top>
                              <template v-slot:activator="{ on }">
                                <v-btn
                                  @click="openPdf(ficheros.pedidos)"
                                  class="px-2 ml-1"
                                  color="info"
                                  min-width="0"
                                  v-on="on"
                                  small
                                >
                                  <v-icon small>mdi-file-pdf-box</v-icon>
                                </v-btn>
                              </template>
                              <span>Descargar pdf</span>
                            </v-tooltip>
                            <v-tooltip top>
                              <template v-slot:activator="{ on }">
                                <v-btn
                                  @click="generarExcel()"
                                  class="px-2 ml-4"
                                  color="info"
                                  min-width="0"
                                  v-on="on"
                                  small
                                >
                                  <v-icon small>mdi-file-excel-box</v-icon>
                                </v-btn>
                              </template>
                              <span>Generar excel y descargar</span>
                            </v-tooltip>
                          </v-col>
                        </v-row>
                        <v-row v-if="ficheros && ficheros.factura">
                          <v-col cols="6">Fichero Factura</v-col>
                          <v-col cols="6">
                            <v-tooltip top>
                              <template v-slot:activator="{ on }">
                                <v-btn
                                  @click="openPdf(ficheros.factura)"
                                  class="px-2 ml-1"
                                  color="info"
                                  min-width="0"
                                  v-on="on"
                                  small
                                >
                                  <v-icon small>mdi-file-pdf-box</v-icon>
                                </v-btn>
                              </template>
                              <span>Descargar pdf</span>
                            </v-tooltip>
                          </v-col>
                        </v-row>
                        <v-row
                          justify="center"
                          v-if="
                            ficheros &&
                            ficheros.resumenComision &&
                            (role == 'admin' || role == 'partner')
                          "
                        >
                          <v-col cols="6">Fichero Resumen Comision</v-col>
                          <v-col cols="6">
                            <v-tooltip top>
                              <template v-slot:activator="{ on }">
                                <v-btn
                                  @click="openPdf(ficheros.resumenComision)"
                                  class="px-2 ml-1"
                                  color="info"
                                  min-width="0"
                                  v-on="on"
                                  small
                                >
                                  <v-icon small>mdi-file-pdf-box</v-icon>
                                </v-btn>
                              </template>
                              <span>Descargar pdf</span>
                            </v-tooltip>
                          </v-col>
                        </v-row>
                        <v-row v-if="ficheros && ficheros.recibo">
                          <v-col cols="6">Fichero recibo cobro</v-col>
                          <v-col cols="6">
                            <v-tooltip
                              top
                              v-if="ficheros && ficheros.reciboCobro"
                            >
                              <template v-slot:activator="{ on }">
                                <v-btn
                                  @click="openPdf(ficheros.reciboCobro)"
                                  class="px-2 ml-1"
                                  color="info"
                                  min-width="0"
                                  v-on="on"
                                  small
                                >
                                  <v-icon small>mdi-open-in-new</v-icon>
                                </v-btn>
                              </template>
                              <span>Abrir</span>
                            </v-tooltip>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item key="4">
                <v-card flat>
                  <v-card-text v-if="previsualizar">
                    <v-alert class="info"
                      >Cuando se genere la factura se permitirán realizar
                      acciones</v-alert
                    >
                  </v-card-text>
                  <v-card-text>
                    <v-row justify="center">
                      <v-col cols="12" sm="10" md="8">
                        <v-row v-if="ficheros && ficheros.pedidos">
                          <v-col cols="5">Transferencia al negocio</v-col>
                          <v-col cols="1">
                            <v-tooltip top v-if="ficheros && ficheros.pedidos">
                              <template v-slot:activator="{ on }">
                                <v-btn
                                  :disabled="transferidoAlNegocio != false"
                                  @click="pagarNegocio()"
                                  class="px-2 ml-1"
                                  color="info"
                                  min-width="0"
                                  v-on="on"
                                  small
                                  :loading="btnAccionesLoading"
                                >
                                  <v-icon small>mdi-currency-eur</v-icon>
                                </v-btn>
                              </template>
                              <span
                                >Transferir al negocio la cantidad de
                                {{ resumen.totalTransferir }}</span
                              >
                            </v-tooltip>
                          </v-col>
                          <v-col cols="1" v-if="transferidoAlNegocio">
                            <v-tooltip top>
                              <template v-slot:activator="{ on }">
                                <v-btn
                                  @click="cancelarTransferencia()"
                                  class="px-2 ml-1"
                                  color="red"
                                  min-width="0"
                                  v-on="on"
                                  small
                                  :loading="btnAccionesLoading"
                                >
                                  <v-icon small>mdi-backup-restore</v-icon>
                                </v-btn>
                              </template>
                              <span>Intentar cancelar la transferencia</span>
                            </v-tooltip>
                          </v-col>
                          <v-col cols="5" v-if="transferidoAlNegocio">
                            <span
                              >Realizado por
                              {{
                                transferidoAlNegocio.transferidoNegocioUsuario
                              }}
                              el
                              {{
                                transferidoAlNegocio.transferidoNegocioMostrar
                              }}</span
                            >
                          </v-col>
                        </v-row>
                        <v-row align="center">
                          <v-col cols="5">Pagar a Mewo</v-col>
                          <v-col cols="2">
                            <v-tooltip top>
                              <template v-slot:activator="{ on }">
                                <v-btn
                                  :disabled="pagadoAMewo != false"
                                  @click="marcarPagadoDialog = true"
                                  class="px-2 ml-1"
                                  color="green lighteen-1"
                                  min-width="0"
                                  v-on="on"
                                  small
                                  :loading="btnAccionesLoading"
                                >
                                  <v-icon small>mdi-check</v-icon>
                                </v-btn>
                              </template>
                              <span>Marcar como pagado</span>
                            </v-tooltip>
                            <v-tooltip top>
                              <template v-slot:activator="{ on }">
                                <v-btn
                                  :disabled="pagadoAMewo != false"
                                  @click="pagarMewo()"
                                  class="px-2 ml-1"
                                  color="info"
                                  min-width="0"
                                  v-on="on"
                                  small
                                  :loading="btnAccionesLoading"
                                >
                                  <v-icon small>mdi-currency-eur</v-icon>
                                </v-btn>
                              </template>
                              <span
                                >Transferir a Mewo
                                {{ resumen.transferirMewo }} con la forma de
                                pago seleccionada</span
                              >
                            </v-tooltip>
                          </v-col>
                          <v-col cols="5" v-if="pagadoAMewo">
                            <span>
                              Realizado por
                              {{ pagadoAMewo.transferidoMewoUsuario }} el
                              {{ pagadoAMewo.transferidoMewoMostrar }}</span
                            >
                          </v-col>
                          <v-col cols="5" v-else>
                            <v-row align="center">
                              <v-col cols="10">
                                <v-select
                                  label="Forma de pago"
                                  v-model="formaPagoEleccion"
                                  :items="formasCobroComputed"
                                />
                              </v-col>
                              <v-col cols="2">
                                <v-btn
                                  text
                                  small
                                  class="pa-2"
                                  @click="openFormasPagoDialog"
                                  ><v-icon>mdi-plus</v-icon></v-btn
                                >
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="5">Enviar ficheros</v-col>
                          <v-col cols="1">
                            <v-tooltip top v-if="ficheros">
                              <template v-slot:activator="{ on }">
                                <v-btn
                                  @click="openFicherosDialog()"
                                  class="px-2 ml-1"
                                  color="info"
                                  min-width="0"
                                  v-on="on"
                                  small
                                  :loading="btnAccionesLoading"
                                >
                                  <v-icon small>mdi-send</v-icon>
                                </v-btn>
                              </template>
                              <span>Enviar</span>
                            </v-tooltip>
                          </v-col>
                          <v-col cols="5" v-if="envioEmail.envioEmailUsuario">
                            <span
                              >Realizado por
                              {{ envioEmail.envioEmailUsuario }} el
                              {{ envioEmail.envioEmailMostrar }}</span
                            >
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item key="5">
                <v-card flat>
                  <v-card-title class="headline">
                    HISTORIAL
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <div v-on="on">
                          <v-btn
                            disabled
                            class="px-2 ml-4"
                            color="green"
                            min-width="0"
                            small
                            v-on="on"
                          >
                            <v-icon small>mdi-plus</v-icon>
                          </v-btn>
                        </div>
                      </template>
                      <span>Añadir comentario a la factura</span>
                    </v-tooltip>
                  </v-card-title>
                  <v-card-text>
                    <v-expansion-panels popout>
                      <v-expansion-panel
                        v-for="(h, i) in historiaComputed"
                        :key="i"
                      >
                        <v-expansion-panel-header>
                          <v-row no-gutters>
                            <v-col cols="4">{{
                              h && h.titulo ? h.titulo : "sin titulo"
                            }}</v-col>
                            <v-col cols="4" class="text--secondary">{{
                              h && h.usuario ? h.usuario : "sin usuario"
                            }}</v-col>
                            <v-col cols="4" class="text--secondary">{{
                              h && h.fechaMostrar ? h.fechaMostrar : "sin fecha"
                            }}</v-col>
                          </v-row>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>{{
                          h && h.adicional ? h.adicional : "Sin más información"
                        }}</v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-card>
        </v-container>
      </v-card-text>
    </base-material-card>
    <!--dialogo añadir conceptos a factura-->
    <v-dialog max-width="600" v-model="conceptosFacturarDialog">
      <v-card class="mx-auto">
        <v-row justify="center">
          <v-card-title class="mb-4"
            >Añadir conceptos a la factura</v-card-title
          >
          <v-card-subtitle
            >Selecciona entre los conceptos guardados del negocio o crea uno
            nuevo</v-card-subtitle
          >
          <v-card-text>
            <v-list>
              <v-list-item
                v-for="(concept, i) in conceptosFacturarGuardadosComputed"
                :key="i"
              >
                <v-row justify="center" align="center">
                  <v-col cols="3">
                    <v-list-item-action>
                      <v-row class="pl-3">
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              @click="addConceptoFactura(concept)"
                              class="px-2 ml-1"
                              color="green"
                              min-width="0"
                              small
                              v-on="on"
                            >
                              <v-icon small>mdi-plus</v-icon>
                            </v-btn>
                          </template>
                          <span>Añadir a la factura</span>
                        </v-tooltip>
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              @click="eliminarConceptoGuardar(i)"
                              class="px-2"
                              color="red"
                              min-width="0"
                              small
                              v-on="on"
                              :loading="loadingEliminarConceptoGuardado"
                            >
                              <v-icon small>mdi-delete</v-icon>
                            </v-btn>
                          </template>
                          <span
                            >Borrar de la base de datos de este negocio</span
                          >
                        </v-tooltip>
                      </v-row>
                    </v-list-item-action>
                  </v-col>
                  <v-col cols="9">
                    <v-list-item-content>
                      <v-row justify="center" class="px-auto">
                        <v-col cols="6">
                          <span>{{ concept.textoMostrar }}</span>
                        </v-col>
                        <v-col col="2">
                          <span class="text-right">{{
                            concept.cantidadMostrar
                          }}</span>
                        </v-col>
                        <v-col col="2">
                          <span class="text-right">{{
                            concept.impuestoMostrar
                          }}</span>
                        </v-col>
                      </v-row>
                    </v-list-item-content>
                  </v-col>
                </v-row>
              </v-list-item>
              <v-list-item v-if="addConceptoAGuardar">
                <v-row justify="center" align="center">
                  <v-col cols="3">
                    <v-list-item-action>
                      <v-row class="pl-3">
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              @click="crearConceptoFacturar()"
                              class="px-2 ml-1"
                              color="green"
                              min-width="0"
                              small
                              v-on="on"
                            >
                              <v-icon small>mdi-check</v-icon>
                            </v-btn>
                          </template>
                          <span>Crear concepto a facturar</span>
                        </v-tooltip>
                        <!--<v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            @click="addConceptoFactura(concept)"
                            class="px-2"
                            color="orange"
                            min-width="0"
                            small
                            v-on="on"
                            :loading="loadingEliminarConceptoGuardado"
                          >
                            <v-icon small>mdi-close</v-icon>
                          </v-btn>
                        </template>
                        <span>Cancelar crear concepto</span>
                        </v-tooltip>-->
                      </v-row>
                    </v-list-item-action>
                  </v-col>
                  <v-col cols="9">
                    <v-list-item-content>
                      <v-row justify="center" class="px-auto">
                        <v-col cols="6">
                          <v-text-field
                            v-model="conceptoAGuardar.nombre"
                            label="Nombre concepto"
                          />
                        </v-col>
                        <v-col col="2">
                          <v-text-field
                            v-model="conceptoAGuardar.cantidad"
                            label="Cantidad en euros"
                          />
                        </v-col>
                        <v-col col="2">
                          <v-select
                            v-model="conceptoAGuardar.impuesto"
                            label="Impuesto a aplicar"
                            :items="
                              $store.getters['impuestos/getImpuestosSelect']
                            "
                          />
                        </v-col>
                      </v-row>
                    </v-list-item-content>
                  </v-col>
                </v-row>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-row>
      </v-card>
    </v-dialog>
    <!-- diaologo confirmar marcar pagado-->
    <v-dialog max-width="700" v-model="marcarPagadoDialog">
      <v-card class="mx-auto">
        <v-row justify="center">
          <v-col cols="12">
            <v-card-title class="mb-4">Marcar pagado</v-card-title>
            <v-card-subtitle class="text-center"
              >Escribe un motivo para marcar como pagado (ejemplo: recibos
              sabadell)</v-card-subtitle
            >
            <v-card-text>
              <v-col cols="12" sm="10" md="8" class="mx-auto">
                <v-text-field v-model="marcarPagadoMotivo" label="Motivo" />
              </v-col>
            </v-card-text>
          </v-col>

          <v-card-actions>
            <v-btn
              class="primary"
              @click="marcarPagadoConfirmar"
              :loading="marcarPagadoLoading"
              >Confirmar marcar pagado</v-btn
            >
          </v-card-actions>
        </v-row>
      </v-card>
    </v-dialog>
    <!--dialogo enviar ficheros-->
    <v-dialog max-width="700" v-model="enviarFicherosDialog">
      <v-card class="mx-auto">
        <v-row justify="center">
          <v-col cols="12" sm="6">
            <v-card-title class="mb-4">Ficheros a enviar</v-card-title>
            <v-card-subtitle
              >Selecciona los ficheros que quieres enviar</v-card-subtitle
            >
            <v-card-text>
              <v-list-item-group v-model="ficherosEnviar" multiple>
                <v-list-item value="facturas">
                  <template v-slot:default="{ active }">
                    <v-list-item-action>
                      <v-checkbox
                        :input-value="active"
                        color="primary"
                      ></v-checkbox>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>Factura</v-list-item-title>
                      <v-list-item-subtitle
                        >Factura generada</v-list-item-subtitle
                      >
                    </v-list-item-content>
                  </template>
                </v-list-item>
                <v-list-item
                  value="listado"
                  :disabled="ficheros && !ficheros.pedidos"
                >
                  <template v-slot:default="{ active }">
                    <v-list-item-action>
                      <v-checkbox
                        :input-value="active"
                        color="primary"
                      ></v-checkbox>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>Pedidos</v-list-item-title>
                      <v-list-item-subtitle
                        >Listado de pedidos</v-list-item-subtitle
                      >
                    </v-list-item-content>
                  </template>
                </v-list-item>
                <v-list-item
                  value="resumen"
                  :disabled="ficheros && !ficheros.resumenFactura"
                >
                  <template v-slot:default="{ active }">
                    <v-list-item-action>
                      <v-checkbox
                        :input-value="active"
                        color="primary"
                      ></v-checkbox>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>Resumen</v-list-item-title>
                      <v-list-item-subtitle>Información</v-list-item-subtitle>
                    </v-list-item-content>
                  </template>
                </v-list-item>
              </v-list-item-group>
            </v-card-text>
          </v-col>
          <v-col cols="12" sm="6">
            <v-card-title class="mb-4">Emails a enviar</v-card-title>
            <v-card-subtitle
              >Selecciona los emails a los que quieres enviar</v-card-subtitle
            >
            <v-card-text>
              <v-list-item-group v-model="emailsEnviar" multiple>
                <v-list-item
                  :value="e"
                  v-for="(e, i) in datosFacturacion.emails"
                  :key="i"
                >
                  <template v-slot:default="{ active }">
                    <v-list-item-action>
                      <v-checkbox
                        :input-value="active"
                        color="primary"
                      ></v-checkbox>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>{{ e }}</v-list-item-title>
                      <v-list-item-subtitle></v-list-item-subtitle>
                    </v-list-item-content>
                  </template>
                </v-list-item>
              </v-list-item-group>
            </v-card-text>
          </v-col>
          <v-card-actions>
            <v-btn
              large
              class="primary"
              @click="enviarFicheros"
              :loading="btnAccionesLoading"
              >Enviar</v-btn
            >
          </v-card-actions>
        </v-row>
      </v-card>
    </v-dialog>
    <!--dialogo añadir formas de pago-->
    <v-dialog max-width="700" v-model="formasPagoDialog">
      <v-card class="mx-auto">
        <v-row justify="center">
          <v-col cols="12">
            <v-card-title class="mb-4">Formas de pago del negocio</v-card-title>
            <v-card-subtitle class="text-center"
              >Añade una nueva forma de pago para el negocio</v-card-subtitle
            >
            <v-card-text>
              <v-list>
                <v-list-item>
                  <v-list-item-action>
                    <v-icon>mdi-remove</v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>Factura</v-list-item-title>
                    <v-list-item-subtitle
                      >Factura generada</v-list-item-subtitle
                    >
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card-text>
          </v-col>

          <v-card-actions>
            <v-btn
              class="primary"
              @click="guardarFormaPago"
              :loading="btnGuardarFormasPagoLoading"
              >Añadir forma de pago</v-btn
            >
          </v-card-actions>
        </v-row>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { loadStripe } from "@stripe/stripe-js";
import { apikey } from "@/stripe.js";
import moment from "moment";
var _ = require("lodash");
import { idToTexto, mostrarMoneda, redondeo } from "@/utils/utils.js";
export default {
  data() {
    return {
      addTarifaOnline: true, //añade automáticamente concepto online
      formTitle: "Nueva Factura",
      id_factura: null,
      tab: 0,
      loadingPrevisualizar: false,
      loadingStripe: false,
      loadingGenerar: false,
      loadingSelect: false,
      restaurante: null,
      restaurantesArray: [], //si el restaurante a facturar es matriz, aquí se almacenan los asociados
      ficheros: null,
      historial: [],
      facturacionRestaurante: {
        cuentaAsociada: "",
        tasaPorcentajePedidoPagoOnline: 0,
        tasaFijaPedidoPagoOnline: 0,
        tasaPorcentajePedido: 0,
        tasaFijaPedido: 0,
        tasaFijaServicio: 0,
      },
      nombreFactura: "",
      headers: [
        {
          sortable: false,
          text: "#",
          value: "id",
        },
        {
          sortable: false,
          text: "Fecha",
          value: "fecha",
        },
        {
          sortable: false,
          text: "Modo",
          value: "modo",
        },
        {
          sortable: false,
          text: "Pago",
          value: "forma_pago",
        },
        {
          sortable: false,
          text: "Cantidad",
          value: "precioTotal",
        },
        {
          sortable: false,
          text: "% Online",
          value: "tasaPagoTarjetaPorcentaje",
        },
        {
          sortable: false,
          text: "Fijo Online",
          value: "tasaPagoTarjetaFijo",
        },
        {
          sortable: false,
          text: "% Pedido",
          value: "tasaPedidoPorcentaje",
        },
        {
          sortable: false,
          text: "Fijo Pedido",
          value: "tasaPedidoFijo",
        },
        {
          sortable: false,
          text: "Total Tasa",
          value: "totalTasaPedido",
        },
      ],
      conceptosFacturar: [],
      conceptosFacturarDialog: false,
      enviarFicherosDialog: false,
      ficherosEnviar: [],
      emailsEnviar: [],
      emailsDefecto: [],
      pedidosFactura: [],
      resumen: {
        totalCantidadFacturar: 0,
        totalTasas: 0, //valor a facturar al negocio que debe pagar por pedidos online, sin impuesto
        totalTasasConImpuesto: 0,
        totalFacturado: 0,
        totalDomicilio: 0,
        totalRecoger: 0,
        totalTarjetaOnline: 0,
        totalEfectivo: 0,
        totalPagoEnLocal: 0,
        totalTarjetaDomicilio: 0,
        totalEnStripe: 0,
        totalPagar: 0, //una vez descontada de stripe, si no hubiese fondo
        totalTransferir: 0, //una vez descontada totalTasas
        transferirMewo: 0,
      },
      estado: "borrador",
      loadingEliminarConceptoGuardado: false,
      addConceptoAGuardar: true,
      conceptoAGuardar: {
        nombre: "",
        cantidad: 0,
        impuesto: null,
      },
      btnAccionesLoading: false,
      cambiarCantidadStripe: false,
      cambiarCantidadStripeNuevo: 0,
      //formasPago
      formasPagoDialog: false,
      btnGuardarFormasPagoLoading: false,
      formasPago: [],
      formaPagoEleccion: "conectada",
      cambiarCantidadCobrarNuevo: "",
      cambiarCantidadCobrar: false,
      marcarPagadoMotivo: "recibos sabadell",
      marcarPagadoDialog: false,
      marcarPagadoLoading: false,
    };
  },
  computed: {
    esPedidosOnline() {},
    datesFormateado() {
      return [
        moment(this.dates[0]).format("DD-MM-YYYY"),
        moment(this.dates[1]).format("DD-MM-YYYY"),
      ];
    },
    restaurantesArrayId() {
      return this.restaurantesArray.map((r) => r.id);
    },
    downloadedPedidos() {
      return this.pedidos.length;
    },
    datosFacturacion() {
      return this.factNegocio || this.factDirectorio
        ? this.datosFacturacionNegocio
        : this.facturacionRestaurante;
    },
    transferidoAlNegocio() {
      var found,
        index = this.historial.length - 1;
      for (; index >= 0; index--) {
        if (this.historial[index].transferidoNegocio != undefined) {
          found = this.historial[index];
          break;
        }
      }
      if (found) {
        return {
          ...found,
          transferidoNegocioMostrar: moment(
            found.transferidoNegocio.toDate()
          ).format("DD-MM-YYYY HH:mm"),
        };
      } else {
        return false;
      }
    },
    pagadoAMewo() {
      var found,
        index = this.historial.length - 1;
      for (; index >= 0; index--) {
        if (this.historial[index].transferidoMewo != undefined) {
          found = this.historial[index];
          break;
        }
      }
      if (found) {
        return {
          ...found,
          transferidoMewoMostrar: moment(found.transferidoMewo.toDate()).format(
            "DD-MM-YYYY HH:mm"
          ),
        };
      } else {
        return false;
      }
    },
    envioEmail() {
      var found,
        index = this.historial.length - 1;
      for (; index >= 0; index--) {
        if (this.historial[index].envioEmail != undefined) {
          found = this.historial[index];
          break;
        }
      }
      if (found) {
        return {
          ...found,
          envioEmailMostrar: moment(found.envioEmail.toDate()).format(
            "DD-MM-YYYY HH:mm"
          ),
        };
      } else {
        return false;
      }
    },
    conceptosFacturarGuardadosComputed() {
      var res = [];
      if (
        this.datosFacturacion &&
        this.datosFacturacion.conceptosFacturarGuardados
      ) {
        this.datosFacturacion.conceptosFacturarGuardados.forEach((c) => {
          let foundImp = this.$store.state.impuestos.impuestosArray.find(
            (imp) => imp.id == c.impuesto
          );
          res.push({
            ...c,
            textoMostrar: c.nombre ? c.nombre.toUpperCase() : "",
            impuestoMostrar: foundImp
              ? foundImp.nombre.toUpperCase()
              : "SIN DATOS",
            impuestoCantidad: foundImp ? foundImp.impuesto : 0,
            cantidadMostrar: mostrarMoneda(c.cantidad),
          });
        });
      }
      return res;
    },
    previsualizar() {
      return this.estado == "previsualizar";
    },
    generada() {
      return this.estado == "generada" || this.estado == "enviada cliente";
    },
    archivada() {
      return this.estado == "archivada";
    },
    borrador() {
      return this.estado == "borrador";
    },
    negocio: {
      get() {
        return this.$store.state.app.negocioGest
          ? this.$store.state.app.negocioGest
          : this.$store.state.app.directorioGest
          ? "directorio_" + this.$store.state.app.directorioGest
          : null;
      },
      set(item) {
        let iDir = item.indexOf("directorio_");

        if (iDir > -1) {
          //directorio
          let id = item.replace("directorio_", "");
          this.$store.commit("app/setNegocioGest", null);
          this.$store.commit("app/setDirectorioGest", id);

          if (!this.id_factura) {
            this.initDirectorio();
          } else {
            this.$store
              .dispatch("facturacion/getDatosFacturacionDirectorioGest")
              .then(() => {
                // if (this.restaurante) this.cambioRestaurante();
              });
          }
          return;
        } else {
          this.$store.commit("app/setNegocioGest", item);
          this.$store.commit("app/setDirectorioGest", null);
          if (!this.id_factura) {
            this.initNegocio();
          } else {
            //this.initNegocio();
            this.$store
              .dispatch("facturacion/getDatosFacturacionNegocioGest")
              .then(() => {
                if (this.restaurante) this.cambioRestaurante();
              });
          }
        }
      },
    },
    ...mapGetters({
      role: "auth/role",
    }),
    ...mapState({
      overlayPedidos: (state) => state.facturacion.overlayPedidos,
      pedidosRango: (state) => state.facturacion.pedidosRango,
      negociosItemsBruto: (state) => state.app.negociosGestArray,
      directorios: (state) => state.directorios.directorios,

      datosFacturacionNegocio: (state) =>
        state.facturacion.datosFacturacionNegocioGest,
    }),
    negociosItems() {
      return [
        {
          header: "NEGOCIOS",
        },
        ...this.negociosItemsBruto.map((n) => {
          return {
            ...n,
            tipo: "Negocio",
          };
        }),
        {
          header: "DIRECTORIOS",
        },
        ...this.directorios.map((d) => {
          return {
            text: d.nombre,
            value: "directorio_" + d.id,
            tipo: "Directorio",
          };
        }),
      ];
    },
    ver() {
      return this.id_factura != null;
    },
    pedidos() {
      var res = [];
      const datosFacturacion =
        this.factNegocio || this.factDirectorio
          ? this.datosFacturacionNegocio
          : this.facturacionRestaurante;
      var tasaTotal = 0;
      var total = 0;
      var totalDomicilio = 0;
      var totalRecoger = 0;
      var totalTarjetaOnline = 0;
      var totalEfectivo = 0;
      var totalPagoEnLocal = 0;
      var totalTarjetaDomicilio = 0;
      if (this.pedidosRango.length > 0) {
        this.pedidosRango.forEach((p) => {
          p.precioTotal = parseFloat(p.precioTotal);
          let pTotalAux = redondeo(p.precioTotal);
          let tasaPagoTarjetaPorcentaje = 0;
          let tasaPagoTarjetaFijo = 0;
          let tasaPedidoFijo = 0;
          let tasaTotalAux = 0;
          let tasaPedidoPorcentaje = 0;
          if (p.eliminado != 1) {
            tasaPagoTarjetaPorcentaje =
              p.forma_pago == "tarjeta_online"
                ? redondeo(
                    p.precioTotal *
                      parseFloat(
                        datosFacturacion.tasaPorcentajePedidoPagoOnline
                      )
                  )
                : 0;
            tasaPagoTarjetaFijo =
              p.forma_pago == "tarjeta_online"
                ? parseFloat(datosFacturacion.tasaFijaPedidoPagoOnline)
                : 0;
            tasaPedidoPorcentaje = parseFloat(
              datosFacturacion.tasaPorcentajePedido
            )
              ? redondeo(
                  p.precioTotal *
                    parseFloat(datosFacturacion.tasaPorcentajePedido)
                )
              : 0;
            tasaPedidoFijo = parseFloat(datosFacturacion.tasaFijaPedido)
              ? parseFloat(datosFacturacion.tasaFijaPedido)
              : 0;
            tasaTotalAux = redondeo(
              tasaPagoTarjetaPorcentaje +
                tasaPagoTarjetaFijo +
                tasaPedidoPorcentaje +
                tasaPedidoFijo
            );

            //según pago
            switch (p.forma_pago) {
              case "tarjeta_online":
                totalTarjetaOnline += pTotalAux;
                break;
              case "efectivo":
                totalEfectivo += pTotalAux;
                break;
              case "tarjeta_domicilio":
                totalTarjetaDomicilio += pTotalAux;
                break;
              case "local":
                totalPagoEnLocal += pTotalAux;
                break;
            }
            //según envío
            switch (p.modo) {
              case "domicilio":
                totalDomicilio += pTotalAux;
                break;
              case "recoger":
                totalRecoger += pTotalAux;
                break;
            }
            tasaTotal += tasaTotalAux;
            total += pTotalAux;
          }
          res.push({
            id: p.id,
            //numPedidoRest: p.numPedidoRest,
            fecha: p.fecha,
            modo: idToTexto(p.modo),
            forma_pago: idToTexto(p.forma_pago),
            precioTotal: pTotalAux,
            tasaPagoTarjetaPorcentaje: tasaPagoTarjetaPorcentaje,
            tasaPagoTarjetaFijo: tasaPagoTarjetaFijo,
            tasaPedidoPorcentaje: tasaPedidoPorcentaje,
            tasaPedidoFijo: tasaPedidoFijo,
            tasaTotal: tasaTotalAux,
            eliminado: p.eliminado ? p.eliminado : 0,
          });
        });
        this.resumen.totalTasas = redondeo(tasaTotal);
        this.resumen.totalFacturado = redondeo(total);
        this.resumen.totalDomicilio = redondeo(totalDomicilio);
        this.resumen.totalRecoger = redondeo(totalRecoger);
        this.resumen.totalTarjetaOnline = redondeo(totalTarjetaOnline);
        this.resumen.totalEfectivo = redondeo(totalEfectivo);
        this.resumen.totalTarjetaDomicilio = redondeo(totalTarjetaDomicilio);
        this.resumen.totalPagoEnLocal = redondeo(totalPagoEnLocal);
        let impuesto = this.datosFacturacion.impuesto;

        let foundImp = this.$store.state.impuestos.impuestosArray.find(
          (i) => i.id == impuesto
        );

        if (
          this.resumen.totalTasas > 0 &&
          this.addTarifaOnline &&
          !this.overlayPedidos
        ) {
          var found = this.conceptosFacturar.find(
            (c) => c.texto == "Cuota pedidos online"
          );
          if (!found) {
            this.addConceptoFactura({
              cantidad: this.resumen.totalTasas,
              cantidadMostrar: mostrarMoneda(this.resumen.totalTasas),
              impuesto: foundImp.id,
              impuestoMostrar: foundImp ? foundImp.nombre : "Sin datos",
              impuestoCantidad: foundImp ? foundImp.impuesto : 0,
              texto: "Cuota pedidos online",
              textoMostrar: "CUOTA PEDIDOS ONLINE",
            });
          }
          this.totalCantidadFacturarMetodo();
        }
      }

      return res;
    },
    dates: {
      get() {
        return this.$store.state.facturacion.rangoFacturando;
      },
      set(val) {
        this.$store.commit("facturacion/setRangoFacturando", val);
      },
    },
    factNegocio() {
      return (
        this.datosFacturacionNegocio &&
        this.datosFacturacionNegocio.modoFacturacion == "negocio"
      );
    },
    factIndependiente() {
      return (
        this.datosFacturacionNegocio &&
        this.datosFacturacionNegocio.modoFacturacion == "restauranteIndividual"
      );
    },
    factDirectorio() {
      return (
        this.datosFacturacionNegocio &&
        this.datosFacturacionNegocio.modoFacturacion == "directorio"
      );
    },
    facturacionTipo() {
      return this.restaurante //pasamos el tipo, o restaurante, o directorio o negocio
        ? "restaurante"
        : this.factDirectorio
        ? "directorio"
        : "negocio";
    },

    historiaComputed() {
      var hs = [...this.historial];
      var res = [];
      hs.forEach((h) => {
        let aux;
        if (h.hasOwnProperty("generadaFecha")) {
          aux = {
            fecha: h.generadaFecha.seconds,
            fechaMostrar: moment(h.generadaFecha.toDate()).format(
              "HH:mm DD-MM-YYYY"
            ),
            titulo: "GENERADA",
            usuario: h.generadaUsuario,
          };
        } else if (h.hasOwnProperty("transferidoNegocio")) {
          aux = {
            fecha: h.transferidoNegocio.seconds,
            fechaMostrar: moment(h.transferidoNegocio.toDate()).format(
              "HH:mm DD-MM-YYYY"
            ),
            titulo: "PAGADO AL NEGOCIO",
            usuario: h.transferidoNegocioUsuario,
            adicional: h.transferidoNegocioPayout,
          };
        } else if (h.hasOwnProperty("transferidoMewo")) {
          aux = {
            fecha: h.transferidoMewo.seconds,
            fechaMostrar: moment(h.transferidoMewo.toDate()).format(
              "HH:mm DD-MM-YYYY"
            ),
            titulo:
              "COBRADO : " +
              (h.transferidoMewoModo
                ? h.transferidoMewoModo.toUpperCase()
                : ""),
            usuario: h.transferidoMewoUsuario,
            adicional: h.transferidoMewoPayout,
          };
        } else if (h.hasOwnProperty("envioEmail")) {
          aux = {
            fecha: h.envioEmail.seconds,
            fechaMostrar: moment(h.envioEmail.toDate()).format(
              "HH:mm DD-MM-YYYY"
            ),
            titulo: "ENVIADO EMAIL",
            usuario: h.envioEmailUsuario,
            adicional: h.envioEmailAdicional,
          };
        } else if (h.hasOwnProperty("transferidoNegocioCancel")) {
          aux = {
            fecha: h.transferidoNegocioCancel.seconds,
            fechaMostrar: moment(h.transferidoNegocioCancel.toDate()).format(
              "HH:mm DD-MM-YYYY"
            ),
            titulo: "PAGO AL NEGOCIO CANCELADO",
            usuario: h.transferidoNegocioUsuarioCancel,
            adicional: h.transferidoNegocioPayoutCancel,
          };
        } else if (h.hasOwnProperty("cambioCantidadTransferir")) {
          aux = {
            fecha: h.cambioCantidadTransferir.seconds,
            fechaMostrar: moment(h.cambioCantidadTransferir.toDate()).format(
              "HH:mm DD-MM-YYYY"
            ),
            titulo: "CAMBIO CANTIDAD TRANSFERIR",
            usuario: h.cambioCantidadTransferirUsuario,
            adicional: h.cambioCantidadTransferirAdicional,
          };
        } else if (h.hasOwnProperty("archivada")) {
          aux = {
            fecha: h.archivada.seconds,
            fechaMostrar: moment(h.archivada.toDate()).format(
              "HH:mm DD-MM-YYYY"
            ),
            titulo: "ARCHIVADA",
            usuario: h.archivadaUsuario,
          };
        } else if (h.hasOwnProperty("cambioCantidadCobrar")) {
          aux = {
            fecha: h.cambioCantidadCobrar.seconds,
            fechaMostrar: moment(h.cambioCantidadCobrar.toDate()).format(
              "HH:mm DD-MM-YYYY"
            ),
            titulo: "CAMBIO CANTIDAD A COBRAR",
            usuario: h.cambioCantidadCobrarUsuario,
            adicional: h.cambioCantidadCobrarAdicional,
          };
        } else if (h.hasOwnProperty("comisionGenerada")) {
          aux = {
            fecha: h.comisionGenerada.seconds,
            fechaMostrar: moment(h.comisionGenerada.toDate()).format(
              "HH:mm DD-MM-YYYY"
            ),
            titulo: "GENERADA COMISIÓN",
            usuario: h.comisionGeneradaUsuarioi,
            adicional: h.comisionGeneradaAdicional,
          };
        }
        res.push(aux);
      });
      return res.sort((a, b) => b.fecha - a.fecha);
    },
    formasCobroComputed() {
      var r = this.formasPago.map((f) => {
        switch (f.type) {
          case "sepa_debit":
            return {
              text: "CUENTA BANCARIA TERMINADA EN " + f.sepa_debit.last4,
              value: f.id,
            };
        }
      });
      return [...r, ...this.$store.state.facturacion.formasCobroFactura];
    },
  },
  asyncComputed: {
    restaurantesFiltrados: {
      get() {
        var rest;
        var aux;
        var promesas = [];
        rest = this.$store.state.app.restaurantesArray;
        var res = rest;
        if (this.negocio) res = rest.filter((e) => e.negocio == this.negocio);
        res.forEach((val) => {
          promesas.push(
            this.$store
              .dispatch("restaurantes/getFacturacion", val.id)
              .then((r) => {
                return { ...r, ...val };
              })
          );
        });
        let _vm = this;
        return Promise.all(promesas).then((f) => {
          //todos los restaurantese con sus datos de facturación
          const devolver = f.map((a) => {
            if (a.copiarRest && a.copiarRest != "matriz") {
              a.disabled = true;
            }
            return a;
          });
          return devolver;
        });
      },
      default: [],
    },
  },
  watch: {
    ficherosEnviar(v) {},
    restaurante(v) {
      this.restaurantesArray = [];
      let r = this.restaurantesFiltrados.find((a) => a.id == v);
      if (r) {
        this.restaurantesArray = this.restaurantesFiltrados.filter(
          (a) => a.copiarRest == v
        );
        this.restaurantesArray.unshift(r);
      }
    },
    enviarFicherosDialog(v) {
      if (!v) {
      }
    },
    marcarPagadoDialog(v) {
      v || (this.marcarPagadoMotivo = "");
    },
  },
  methods: {
    openFormasPagoDialog() {
      this.formasPagoDialog = true;
    },
    guardarFormaPago() {
      let _vm = this;
      _vm.btnGuardarFormasPagoLoading = true;
      return this.$store
        .dispatch("facturacion/guardarFormaPago", this.id_factura)
        .then(async (r) => {
          const stripe = await loadStripe(apikey);
          stripe.redirectToCheckout({
            sessionId: r,
          });
        })
        .then(() => {
          _vm.$store.commit("snackbar/setMensajeSuccess", {
            msj: "Forma de pago guardada",
          });
        })
        .catch((e) => {
          _vm.$store.commit("snackbar/setMensajeDanger", {
            msj: "Error al eliminar " + e,
          });
        })
        .finally(() => {
          _vm.$store.dispatch("facturacion/getDatosFacturacionNegocioGest");
          _vm.btnGuardarFormasPagoLoading = false;
        });
    },
    async openFicherosDialog() {
      this.ficherosEnviar = ["facturas"];
      if (this.pedidosFactura.length > 0) {
        this.ficherosEnviar.push("resumen");
        this.ficherosEnviar.push("listado");
      }
      this.emailsEnviar = this.datosFacturacion.emails;
      this.emailsDefecto = await this.$store.dispatch(
        "facturacion/getEmailsDefecto"
      );
      let em = this.datosFacturacion.emails ? this.datosFacturacion.emails : [];
      this.datosFacturacion.emails = _.union(
        this.datosFacturacion.emails,
        this.emailsDefecto
      );
      this.enviarFicherosDialog = true;
    },
    eliminarConceptoGuardar(index) {
      let toSave = JSON.parse(
        JSON.stringify(
          this.datosFacturacion.conceptosFacturarGuardados
            ? this.datosFacturacion.conceptosFacturarGuardados
            : []
        )
      );
      if (index > -1) {
        toSave.splice(index, 1);
      }
      let _vm = this;
      return this.$store
        .dispatch("facturacion/guardarConceptoFacturar", {
          conceptos: toSave,
          restaurante: this.restaurante,
          negocio: this.negocio,
        })
        .then(() => {
          if (this.restaurante) {
            return _vm.cambioRestaurante();
          }
        })
        .then(() => {
          _vm.$store.commit("snackbar/setMensajeSuccess", {
            msj: "Concepto eliminado en la base de datos",
          });
          _vm.conceptoAGuardar = {
            nombre: "",
            cantidad: 0,
            impuesto: null,
          };
        })
        .catch((e) => {
          _vm.$store.commit("snackbar/setMensajeDanger", {
            msj: "Error al eliminar " + e,
          });
        })
        .finally(() => {
          _vm.$store.dispatch("facturacion/getDatosFacturacionNegocioGest");
        });
    },
    crearConceptoFacturar() {
      let toSave = JSON.parse(
        JSON.stringify(
          this.datosFacturacion.conceptosFacturarGuardados
            ? this.datosFacturacion.conceptosFacturarGuardados
            : []
        )
      );
      toSave.push(this.conceptoAGuardar);
      let _vm = this;
      return this.$store
        .dispatch("facturacion/guardarConceptoFacturar", {
          conceptos: toSave,
          restaurante: this.restaurante,
          negocio: this.negocio,
        })
        .then(() => {
          if (this.restaurante) {
            return _vm.cambioRestaurante();
          }
        })
        .then(() => {
          _vm.$store.commit("snackbar/setMensajeSuccess", {
            msj: "Concepto guardado en la base de datos",
          });
          _vm.conceptoAGuardar = {
            nombre: "",
            cantidad: 0,
            impuesto: null,
          };
        })
        .catch((e) => {
          _vm.$store.commit("snackbar/setMensajeDanger", {
            msj: "Error al guardar " + e,
          });
        })
        .finally(() => {
          _vm.$store.dispatch("facturacion/getDatosFacturacionNegocioGest");
        });
    },
    totalCantidadFacturarMetodo() {
      let _vm = this;
      var suma = 0;
      var sumaConIva = 0;
      var impuestos = 0;
      var sumaSinFacturar = 0;
      this.conceptosFacturar.forEach((c) => {
        if (c.seFactura) {
          let i = parseFloat(c.impuestoCantidad);
          let iSumar = redondeo(i * parseFloat(c.cantidad));
          impuestos += iSumar;
          suma += parseFloat(c.cantidad);
          sumaConIva += parseFloat(c.cantidad) + iSumar;
        } else {
          sumaSinFacturar += parseFloat(c.cantidad);
        }
      });
      this.resumen.totalCantidadFacturar = redondeo(sumaConIva);
      this.resumen.subtotalCantidadFacturar = redondeo(suma);
      this.resumen.impuestoCantidadFacturar = redondeo(impuestos);
      this.resumen.totalSinFacturar = redondeo(sumaSinFacturar);
      //cantidad que hay quee cobrar,
      var sumaCobrar =
        this.resumen.totalCantidadFacturar + this.resumen.totalSinFacturar;
      this.resumen.sumaCobrar = sumaCobrar;
      if (
        _vm.resumen.totalEnStripe > sumaCobrar &&
        _vm.resumen.totalTarjetaOnline > sumaCobrar
      ) {
        _vm.resumen.totalPagar = 0;
        _vm.resumen.totalTransferir = redondeo(
          _vm.resumen.totalTarjetaOnline - sumaCobrar
        );
        if (_vm.resumen.totalTransferir < 0) _vm.resumen.totalTransferi = 0;
        _vm.resumen.transferirMewo = redondeo(sumaCobrar);
      } else {
        // _vm.resumen.totalPagar = sumaCobrar;
        // _vm.resumen.totalTransferir = _vm.resumen.totalTarjetaOnline;
        // _vm.resumen.transferirMewo = 0;
        //hace lo mismo que el bloque de arriba, se deja por si se rehace
        _vm.resumen.totalPagar = 0;
        _vm.resumen.totalTransferir = redondeo(
          _vm.resumen.totalTarjetaOnline - sumaCobrar
        );
        if (_vm.resumen.totalTransferir < 0) _vm.resumen.totalTransferi = 0;

        _vm.resumen.transferirMewo = redondeo(sumaCobrar);
      }
    },
    addConceptoFactura(concepto) {
      concepto.seFactura = true;
      this.conceptosFacturar.push(concepto);
      this.conceptosFacturarDialog = false;
      this.totalCantidadFacturarMetodo();
    },
    addConcepto() {
      this.conceptosFacturarDialog = true;
    },
    eliminarConcepto(concepto) {
      const index = this.conceptosFacturar.indexOf(concepto);
      if (index > -1) {
        this.conceptosFacturar.splice(index, 1);
      }
      this.totalCantidadFacturarMetodo();
    },
    openPdf(url) {
      window.open(url, "_blank");
    },
    previsualizarMetodo() {
      let _vm = this;
      _vm.loadingPrevisualizar = true;
      _vm.loadingStripe = true;
      this.conceptosFacturar = [];
      Promise.all([
        this.$store
          .dispatch("facturacion/getSaldoCuentaConectada", {
            tipo: this.facturacionTipo, //pasamos el tipo, o restaurante, o directorio o negocio
            id: this.restaurante ? this.restaurante : this.negocio, //en this.negocio está o el directorio o el negocio
          })
          .then((r) => {
            if (r.data.ok) {
              _vm.resumen.totalEnStripe = r.data.cantidad / 100;
              //_vm.totalCantidadFacturarMetodo();
            }
          })
          .finally(() => {
            _vm.loadingStripe = false;
          }),
        this.$store
          .dispatch("facturacion/getPedidosFacturacion", {
            tipo: this.facturacionTipo,
            negocio: this.negocio,
            restaurantes: this.restaurantesArray,
          })
          .then(() => {
            _vm.estado = "previsualizar";
            _vm.pedidosFactura = _vm.pedidos;
          })
          .finally(() => {
            _vm.loadingPrevisualizar = false;
            _vm.$store.commit("facturacion/setOverlayPedidos", false);
          }),
      ]).then(() => {
        _vm.totalCantidadFacturarMetodo();
      });
    },
    generarFactura() {
      let _vm = this;
      _vm.loadingGenerar = true;

      this.$store
        .dispatch("facturacion/generarFactura", {
          pedidos: this.pedidosFactura,
          rango: this.datesFormateado,
          nombre: this.nombreFactura,
          resumen: this.resumen,
          modo: this.datosFacturacionNegocio.modoFacturacion,
          negocio: this.negocio,
          restaurante: this.restaurantesArrayId,
          estado: "generada",
          conceptosFacturar: this.conceptosFacturar,
        })
        .then(async (r) => {
          _vm.id_factura = r;
          _vm.$router.push("/admin/facturacion/form/" + r);
          _vm.montarVerFactura();
          _vm.$store.commit("snackbar/setMensajeSuccess", {
            msj: "Factura generada correctamentee",
          });
          let facturaObj = await this.$store.dispatch(
            "facturacion/getFactura",
            r
          );
          await _vm.$store.dispatch("facturacion/volcarHolded", facturaObj);
        })
        .catch((e) => {
          _vm.$store.commit("snackbar/setMensajeDanger", {
            msj: "Error al generar la factura: " + e,
          });
        })
        .finally(() => {
          _vm.loadingGenerar = false;
        });
    },
    generarNombreFactura() {
      if (this.factNegocio || this.factDirectorio) {
        this.nombreFactura =
          this.negocio +
          "-" +
          this.datesFormateado[0] +
          "-" +
          this.datesFormateado[1];
      } else if (this.factIndependiente) {
        this.nombreFactura =
          this.restaurante +
          "-" +
          this.datesFormateado[0] +
          "-" +
          this.datesFormateado[1];
      }
    },
    initDirectorio() {
      return this.$store.dispatch("loading/getDirectorio");
    },
    initNegocio() {
      this.loadingSelect = true;
      //this.restaurante = null;
      let _vm = this;
      this.$store.dispatch("loading/getNegocio").finally(() => {
        _vm.loadingSelect = false;
      });
    },
    cambioRestaurante() {
      var _vm = this;
      _vm.loadingSelect = true;
      const id = this.restaurante;
      this.$store
        .dispatch("restaurantes/getFacturacion", id)
        .then((r) => {
          if (r) {
            _vm.facturacionRestaurante = r;
          } else {
            _vm.facturacionRestaurante = {
              cuentaAsociada: "",
              tasaPorcentajePedidoPagoOnline: 0,
              tasaFijaPedidoPagoOnline: 0,
              tasaPorcentajePedido: 0,
              tasaFijaPedido: 0,
              tasaFijaServicio: 0,
            };
          }
        })
        .finally(() => {
          _vm.loadingSelect = false;
          this.generarNombreFactura();
        });
    },
    enviarFicheros() {
      //this.$store.dispatch("facturacion/generarPdfFactura", this.id_factura);
      this.btnAccionesLoading = true;
      let _vm = this;
      let aux = [..._vm.emailsEnviar];
      let flagEnviar = aux.length > 0;
      this.$store
        .dispatch("facturacion/enviarFacturaEmail", {
          id: this.id_factura,
          emails: this.emailsEnviar,
          ficheros: this.ficherosEnviar,
          flag: flagEnviar,
        })
        .then((r) => {
          if (!r.data.ok) {
            return Promise.reject(r.data.error);
          } else {
            if (_vm.emailsEnviar)
              _vm.$store.commit("snackbar/setMensajeSuccess", {
                msj: "Ficheros enviados por correo electrónico",
              });
            _vm.enviarFicherosDialog = false;
            return _vm.montarVerFactura();
          }
        })
        .catch((e) => {
          _vm.$store.commit("snackbar/setMensajeDanger", {
            msj: "Error al enviar los ficheros: " + e,
          });
        })
        .finally(() => (_vm.btnAccionesLoading = false));
    },
    cancelarTransferencia() {
      this.btnAccionesLoading = true;
      let _vm = this;
      this.$store
        .dispatch("facturacion/cancelTransfer", this.id_factura)
        .then((r) => {
          if (!r.data.ok) {
            return Promise.reject(r.data.error);
          } else {
            _vm.$store.commit("snackbar/setMensajeSuccess", {
              msj: "Se ha conseguido anular la transferencia",
            });
            return _vm.montarVerFactura();
          }
        })
        .catch((e) => {
          _vm.$store.commit("snackbar/setMensajeDanger", {
            msj: "Error al intentar cancelar la transferencia: " + e,
          });
        })
        .finally(() => (_vm.btnAccionesLoading = false));
    },
    pagarNegocio() {
      this.btnAccionesLoading = true;
      let _vm = this;
      this.$store
        .dispatch("facturacion/payToNegRest", this.id_factura)
        .then((r) => {
          if (!r.data.ok) {
            return Promise.reject(r.data.error);
          } else {
            _vm.$store.commit("snackbar/setMensajeSuccess", {
              msj: "Se ha pagado al Negocio la cantidad estipulada, revise los ficheros",
            });
            return _vm.montarVerFactura();
          }
        })
        .catch((e) => {
          _vm.$store.commit("snackbar/setMensajeDanger", {
            msj: "Error al ejecutar la transferencia: " + e,
          });
        })
        .finally(() => (_vm.btnAccionesLoading = false));
    },
    marcarPagadoConfirmar() {
      this.marcarPagadoLoading = true;
      let _vm = this;
      this.$store
        .dispatch("facturacion/marcarPagado", {
          id: this.id_factura,
          motivo: this.marcarPagadoMotivo,
        })
        .then((r) => {
          _vm.$store.commit("snackbar/setMensajeSuccess", {
            msj: "Se ha marcado como pagada",
          });
          _vm.marcarPagadoDialog = false;
          return _vm.montarVerFactura();
        })
        .catch((e) => {
          _vm.$store.commit("snackbar/setMensajeDanger", {
            msj: "Error al ejecutar la acción: " + e,
          });
        })
        .finally(() => (_vm.marcarPagadoLoading = false));
    },
    pagarMewo() {
      this.btnAccionesLoading = true;
      let _vm = this;
      this.$store
        .dispatch("facturacion/payToMewo", {
          id: this.id_factura,
          modo: this.formaPagoEleccion,
        })
        .then((r) => {
          if (!r.data.ok) {
            return Promise.reject(r.data.error);
          } else {
            _vm.$store.commit("snackbar/setMensajeSuccess", {
              msj: "Se ha cobrado al Negocio la cantidad estipulada, revise los ficheros",
            });
            return _vm.montarVerFactura();
          }
        })
        .catch((e) => {
          _vm.$store.commit("snackbar/setMensajeDanger", {
            msj: "Error al ejecutar el cobro: " + e,
          });
        })
        .finally(() => (_vm.btnAccionesLoading = false));
    },
    montarVerFactura() {
      let _vm = this;
      document.title = "Ver factura " + this.id_factura;
      this.formTitle = "Ver factura " + this.id_factura;
      this.$store
        .dispatch("facturacion/getFactura", this.id_factura)
        .then(async (r) => {
          this.pedidosFactura = await this.$store.dispatch(
            "facturacion/getPedidosFactura",
            this.id_factura
          );
          this.$store
            .dispatch("facturacion/getFormasPago", this.id_factura)
            .then((r) => {
              if (r) _vm.formasPago = r;
            });
          this.dates = r.rango.map((f) =>
            moment(f, "DD-MM-YYYY").format("YYYY-MM-DD")
          );
          if (r.estado != "archivada") {
            _vm.loadingStripe = true;
            this.$store
              .dispatch("facturacion/getSaldoCuentaConectada", {
                tipo: r.modo,
                id:
                  r.modo == "restauranteIndividual" ? r.restaurante : r.negocio,
              })
              .then((r) => {
                if (r.data.ok) {
                  _vm.resumen.totalEnStripe = r.data.cantidad / 100;
                  //_vm.totalCantidadFacturarMetodo();
                }
              })
              .finally(() => {
                _vm.loadingStripe = false;
              });
          }
          this.nombreFactura = r.nombre;

          this.ficheros = r.ficheros;
          this.historial = r.historial;
          //this.datosFacturacionNegocio.modoFacturacion = r.modo;
          this.negocio =
            r.modo == "directorio" ? "directorio_" + r.negocio : r.negocio;
          this.restaurante =
            r.restaurante && Array.isArray(r.restaurante)
              ? r.restaurante[0]
              : null;
          this.restaurantesArray = r.restaurante;
          this.estado = r.estado;
          this.conceptosFacturar = r.conceptosFacturar
            ? r.conceptosFacturar
            : [];
          this.resumen = r.resumen;
        })
        .catch((e) => {
          console.log(e);
          this.$router.push("/admin/facturacion/form");
        });
    },
    cambiarCantidadStripeMetodo() {
      this.cambiarCantidadStripe = true;
      this.cambiarCantidadStripeNuevo = this.resumen.totalTransferir;
    },
    cambiarCantidadStripeConfirmar() {
      let _vm = this;
      this.$store
        .dispatch("facturacion/saveDatoStripeTransferir", {
          id: this.id_factura,
          antes: this.resumen.totalTransferir,
          nuevo: this.cambiarCantidadStripeNuevo,
        })
        .then(() => {
          _vm.$store.commit("snackbar/setMensajeSuccess", {
            msj: "Cantidad cambiada",
          });
          this.cambiarCantidadStripe = false;
          _vm.montarVerFactura();
        })
        .catch((e) => {
          _vm.$store.commit("snackbar/setMensajeDanger", {
            msj: "Error: " + e,
          });
        });
    },
    cambiarCantidadCobrarMetodo() {
      this.cambiarCantidadCobrar = true;
      this.cambiarCantidadCobrarNuevo = this.resumen.transferirMewo;
    },
    cambiarCantidadCobrarConfirmar() {
      let _vm = this;
      this.$store
        .dispatch("facturacion/saveDatosCobrar", {
          id: this.id_factura,
          antes: this.resumen.transferirMewo,
          nuevo: this.cambiarCantidadCobrarNuevo,
        })
        .then(() => {
          _vm.$store.commit("snackbar/setMensajeSuccess", {
            msj: "Cantidad cambiada",
          });
          this.cambiarCantidadCobrar = false;
          _vm.montarVerFactura();
        })
        .catch((e) => {
          _vm.$store.commit("snackbar/setMensajeDanger", {
            msj: "Error: " + e,
          });
        });
    },
    generarExcel() {
      this.$store
        .dispatch("facturacion/generarExcelListadoPedidos", {
          pedidos: this.pedidosFactura,
          id_factura: this.id_factura,
          rango: this.dates,
        })
        .then((r) => {});
    },
  },
  destroyed() {
    this.dates = [null, null];
    this.restaurante = null;
    this.conceptosFacturar = [];
    this.resumen = {
      totalTasas: 0,
      totalFacturado: 0,
      totalDomicilio: 0,
      totalRecoger: 0,
      totalTarjetaOnline: 0,
      totalEfectivo: 0,
      totalPagoEnLocal: 0,
      totalTarjetaDomicilio: 0,
      totalEnStripe: 0,
    };
    this.$store.commit("facturacion/resetPedidosRango");
    this.estado = "borrador";
  },
  mounted() {
    this.id_factura = this.$route.params.id_factura;
    if (this.id_factura) {
      this.montarVerFactura();
    }
  },
};
</script>

<style>
</style>